<template>
  <el-scrollbar>
    <div class="content">
      <div class="collBox" v-if="!isCollapse" @click="isCollapse = true">
        <img src="../assets/images/Collapse.png" style="width: 30px; height: 100%" title="收起" />
      </div>
      <div class="collBox" v-else @click="isCollapse = false">
        <img src="../assets/images/Collapseno.png" style="width: 30px; height: 100%" title="展开" />
      </div>
      <!-- background-color="#4b4b4b" -->
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" :background-color="leftColors"
        @close="closeMenu" @open="openMenu" :collapse="isCollapse" text-color="#51545b" :unique-opened="true"
        :router="true" active-text-color="#fff">
        <el-submenu :index="index(key)" v-for="(item, key) in menuList" :key="key">
          <template slot="title">
            <!--            <div class="icon-item" :class="classObj(key)"></div>-->
            <div class="icon-item" :style="{ marginRight: isCollapse ? '-15px' : '10px' }" ref="oneIcon"
              :class="classObj(key, item)"></div>
            <span :class="[
              'menu-item-name',
              iconIndex === key ? 'activeColor' : '',
            ]">{{ item.name }}</span>
          </template>
          <!--          v-if="!(currentRole==3 && (item1.path == '/index/communityMG' || item1.path =='/index/departmentMG' || item1.path =='/index/employee' || item1.path =='/index/characterMG' || item1.path =='/index/homeMG'  || item1.path =='/index/bedMG'))"-->
          <el-menu-item v-for="item1 in item.child" :key="item1.name" :index="son(item1.path)"><span
              class="menu-item-name">{{
                item1.name }}</span></el-menu-item>
          <!--<el-menu-item index="/layout/work/listOfJobs"><span class="menu-item-name">工作安排</span></el-menu-item>-->
          <!--<el-menu-item index="/warningDeal"><span class="menu-item-name">预警处理</span></el-menu-item>-->
        </el-submenu>
      </el-menu>
      <!-- <div class="l-bottom leftBackground" v-if="leftModeShow">
        <span class="l-b-tit letBottomColor border_bottom">{{
          companyTitle
        }}</span>
        <div class="l-b-time letBottomColor">{{ nowDay }}</div>

        <div
          v-if="operateShow && !tag"
          class="operate-manual text-colors-one"
          @click="operateManual"
        >
          操作手册
        </div>
      </div> -->
    </div>
  </el-scrollbar>
</template>

<script>
import bus from "../libs/bus";
import { get, post } from "../libs/tool";
import { api_listAllMenu } from "../api/api";
export default {
  data() {
    return {
      defaultAct: "",
      isCollapse: false,

      companyTitle: "爱牵挂智慧康养平台",
      leftColors: "#FFFFFF",

      currentOrganId: "", //根据orginId改变icon图标
      toggleMode: "",

      menuList: [], //菜单

      isShowMenu: true,

      currentRole: 0,
      //左下角整个模块隐藏
      leftModeShow: true,
      // 操作手册显示隐藏
      operateShow: true,
      roleId: "",
      iconIndex: "",
      slecetName: "",
      tag: "",
    };
  },
  created() {
    let that = this;
    bus.$on("leftActive", function (to, from) {
      if (to.fullPath !== "/login") {
        that.defaultAct = to.path;
      } else {
        console.log(that.defaultAct);
      }
    });

    bus.$on("toggleMode", function (value) {
      that.toggleMode = value;
      that.modeList();
    });
    let auth = JSON.parse(localStorage.getItem("auth"));
    if (auth.organization.tag == "ninghua") {
      this.slecetName = "人员";
      this.companyTitle = "智能看护系统";
    } else if (auth.organization.tag == "huixinyuan") {
      this.slecetName = "";
      this.companyTitle = "慧心源养老机构智能看护系统";
    } else if (auth.organization.tag == "qingshaonian") {
      this.slecetName = "";
      this.companyTitle = "爱牵挂青少年平安健康系统";
    } else if (auth.organization.tag == "HXJ") {
      this.slecetName = "";
      this.companyTitle = "";
    } else {
      this.slecetName = "";
      this.companyTitle = "爱牵挂智慧康养平台";
    }
  },
  mounted() {
    let that = this;

    let auth = localStorage.getItem("item");

    auth = typeof auth == "string" ? JSON.parse(auth) : auth;
    this.tag = JSON.parse(localStorage.getItem("oem-home"))
      ? JSON.parse(localStorage.getItem("oem-home"))
      : "";
    console.log(this.tag);
    console.log(auth);
    this.currentOrganId = auth.organ_id;
    this.roleId = auth.role_id;
    console.log(this.roleId);
    //this.companyTitle = auth.organ_id == "000000006a90191f016ab5360a3e0398" ? "爱满分养老机构智能看护系统" : auth.organ_id == "000000006a90191f016abe872bea04d7" ?"呼贝远程看护系统" : this.companyTitle ;
    // 动态控制机构名称
    let companyName = sessionStorage.getItem("companyName");
    // 操作手册显示隐藏
    // if(companyName){
    //   this.operateShow = false;
    // }
    //   console.log(companyName,'companyName')
    // if (companyName == "智能看护系统") {
    //     this.companyTitle = "智能看护系统";
    //     that.operateShow = false;
    // } else {
    //     this.companyTitle =
    //         auth.system_name == "" ? this.companyTitle : auth.system_name;
    // }

    this.currentRole = JSON.parse(localStorage.getItem("auth")).role.role_type;

    // // console.log("10010", auth.organ_id)
    // if (auth.organ_id == "000000006b6d88bc016c4ac8f22914bf") {
    //     console.log("我进去了");
    //     this.leftColors = "#2d8cf0";
    // } else if (auth.organ_id == "0000000070ae249601712e9deedf00b5") {
    //     this.leftModeShow = false;
    // } else if (auth.organ_id == "00000000735c100401735c1802b70001") {
    //     this.leftModeShow = false;
    // }

    //菜单
    that.toggleMode = localStorage.getItem("toggleM");
    that.modeList();
    // this.menuList = JSON.parse(localStorage.getItem("auth")).menus ;
    //console.log('menullist',JSON.parse(localStorage.getItem("auth")).menus,this.$store.state.login.authority.menus,this.menuList)
  },
  methods: {
    closeMenu(index) {
      console.log('menuList');
      let k2 = "icon-item" + (Number(index) + 1);
      this.$refs.oneIcon[index].className = `icon-item ${k2}`;
     
    },
    openMenu(index) {
      console.log(index, "ccccccccccccc");
      this.iconIndex = index;
      // let k2 = "icon-item" + (Number(index) + 8);
      // this.$refs.oneIcon[index].className = `icon-item ${k2}`;
    },
    openMenu1(index) {
      console.log(index, "ccccccccccccc111");
      this.iconIndex = index;
      // let k2 = "icon-item" + (Number(index) + 8);
      // this.$refs.oneIcon[index].className = `icon-item ${k2}`;
    },
    index(num) {
      return num.toString();
    },
    son(path) {
      return path;
    },
    classObj(key, item) {
      if (item.name == "工作台") {
        return "icon-item1"
      } else if (item.name == "呼叫中心") {
        return "icon-item2"
      } else if (item.name == "服务派单") {
        return "icon-item3"
      } else if (item.name == "设备管理") {
        return "icon-item4"
      } else if (item.name == "用户管理") {
        return "icon-item5"
      } else if (item.name == "报表统计") {
        return "icon-item6"
      } else if (item.name == "员工管理") {
        return "icon-item7"
      } else if (item.name == "系统设置") {
        return "icon-item8"
      }
      // console.log(item, "keykeyitem.name");
      // let k;
      // k = "icon-item" + (key + 1);
      // return {
      //   [k]: true,
      // };
    },
    mouseOver() {
      this.isCollapse = false;
    },
    mouseOut() {
      this.isCollapse = true;
    },
    operateManual() {
      // window.open("http://fxfk.aiqiangua.com/dist/operate/operationManual.html")
      window.open(
        "https://cc.easyagecare.com/dist/operate/operationManual.html"
      );
    },
    //两种模式切换
    modeList() {
      let data = {
        role_id: this.roleId,
      };
      get(api_listAllMenu, data, (res) => {
        if (res.success) {
          console.log(this.companyTitle);
          let watch = res.data.filter((item) => item.name !== "预警提醒");
          if (this.companyTitle == "智能看护系统") {
            watch.map((v) => {
              if (v.name == "用户管理") {
                v.child[0].name = "人员管理";
              }
              // if (v.name == "设备管理") {
              //   v.child = v.child.splice(0, v.child.length - 3);
              // }
            });
            this.menuList = watch;
            return;
          }
          this.menuList = watch;
        }
      });
    },
  },
  computed: {
    //login_store.js
    list() {
      return this.$store.state.login.authority.menus;
    },
    nowDay() {
      let week = "";
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let n = date.getDay();
      switch (n) {
        case 0:
          week = "天";
          break;
        case 1:
          week = "一";
          break;
        case 2:
          week = "二";
          break;
        case 3:
          week = "三";
          break;
        case 4:
          week = "四";
          break;
        case 5:
          week = "五";
          break;
        case 6:
          week = "六";
          break;
      }
      return y + "年" + m + "月" + d + "日" + " 星期" + week;
    },
  },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../libs/minxin.styl';

// .sidebar-wrapper .el-scrollbar__wrap {
// overflow-x: hidden!important;
// overflow-y: hidden!important;
// }
// /deep/.is-horizontal {
// display:none!important;
// }
// /deep/.is-horizontal {
// display:none!important;
// }
// /deep/.is-vertical{
// display:none!important;
// }
// /* 改变滚动条颜色，或者把/deep/替换成::v-deep  */
// ::v-deep.el-scrollbar__thumb {
// background: #8e97d9!important;
// }
.activeColor {
  color: #ed6d2a;
}

.content {
  // padding-bottom: 100px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}

.el-icon-caret-right {
  opacity: 0;
}

.collBox {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;
}

.el-scrollbar {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .l-bottom {
    position: absolute;
    bottom: 50px;
    width: 100%;
    height: 150px;
    font-size: 14px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    .operate-manual {
      font-size: 23px;
      cursor: pointer;
      margin-top: 3%;
    }

    .l-b-tit {
      font-size: 14px;
      color: #ed6d2a;
      // padding:10px 22px
      border-bottom: 1px solid #ed6d2a;
      margin: 0 auto 10px;
    }

    .l-b-time {
      font-size: 12px;
      color: #aaa;
    }
  }

  .l-title {
    width: 100%;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    text-align: center;
    /* padding-left: 55px */
    fontSize(0.18);
    color: #fff;
    background: rgba(237, 109, 42, 0.6);
  }

  .icon-item {
    width: 30px;
    // height: 40px;
    // background-size: 100%;
    background-position: left center;
    background-repeat: no-repeat;
  }

  .icon-item1 {
    background-image: url('../assets/images/nav_icon_Workb.png');
    // background-size: 35px 45px;
    background-size: 30px;
  }
  .el-menu .el-submenu.is-active .icon-item1 {
    background-image: url('../assets/images/nav_icon_Workb1.png');
    color:#FF6320;
  }
  .el-menu .el-submenu.is-active .el-submenu__title .menu-item-name {
    color:#FF6320;
  }
  .el-menu .el-submenu.is-active .el-submenu__title .el-submenu__icon-arrow {
    color:#FF6320;
  }
  

  .icon-item2 {
    background-image: url('../assets/images/nav_icon_call.png');
    background-size: 30px;
  }
  .el-menu .el-submenu.is-active .icon-item2 {
    background-image: url('../assets/images/nav_icon_call1.png');
  }
  .icon-item3 {
    background-image: url('../assets/images/nav_icon_Service.png');
    background-size: 30px;
  }
  .el-menu .el-submenu.is-active .icon-item3 {
    background-image: url('../assets/images/nav_icon_Service1.png');
  }

  .icon-item4 {
    background-image: url('../assets/images/nav_icon_Equipment.png');
    background-size: 30px;
  }
  .el-menu .el-submenu.is-active .icon-item4 {
    background-image: url('../assets/images/nav_icon_Equipment1.png');
  }

  .icon-item5 {
    background-image: url('../assets/images/nav_icon_User.png');
    background-size: 30px;
  }
  .el-menu .el-submenu.is-active .icon-item5 {
    background-image: url('../assets/images/nav_icon_User1.png');
  }

  .icon-item6 {
    background-image: url('../assets/images/nav_icon_Report.png');
    background-size: 30px;
  }
  .el-menu .el-submenu.is-active .icon-item6 {
    background-image: url('../assets/images/nav_icon_Report1.png');
  }

  .icon-item7 {
    background-image: url('../assets/images/nav_icon_Staff.png');
    background-size: 30px;
  }
   .el-menu .el-submenu.is-active .icon-item7 {
    background-image: url('../assets/images/nav_icon_Staff1.png');
  }

  .icon-item8 {
    background-image: url('../assets/images/nav_icon_System.png');
    background-size: 30px;
  }
   .el-menu .el-submenu.is-active .icon-item8 {
    background-image: url('../assets/images/nav_icon_System1.png');
  }

  .icon-item81 {
    background-image: url('../assets/images/nav_icon_Workb1.png');
    background-size: 30px;
  }

  .icon-item9 {
    background-image: url('../assets/images/nav_icon_Service1.png');
    background-size: 30px;
  }

  .icon-item10 {
    background-image: url('../assets/images/nav_icon_Equipment1.png');
    background-size: 30px;
  }

  .icon-item11 {
    background-image: url('../assets/images/nav_icon_User1.png');
    background-size: 30px;
  }

  .icon-item12 {
    background-image: url('../assets/images/nav_icon_Report1.png');
    background-size: 30px;
  }

  .icon-item13 {
    background-image: url('../assets/images/nav_icon_Staff1.png');
    background-size: 30px;
  }

  .icon-item14 {
    background-image: url('../assets/images/nav_icon_System1.png');
    background-size: 30px;
  }

  .menu-item-name {
    font-size: 14px;
    width: 90px;
    display: block;
    no-wrap();
  }
}
</style>



// WEBPACK FOOTER //
// src/components/left.vue